import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function WhoIsForSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forItems = ['Jóvenes de 20 a 30 años que viven en pisos pequeños con balcón o ventana', 'Personas cansadas de pagar precios absurdos por vegetales de baja calidad', 'Principiantes absolutos que creen que matan hasta un cactus', 'Buscadores de una vida más sostenible y consciente sin mudarse al campo'];
  const notForItems = ['Personas con grandes terrenos o jardines (esto es para micro-espacios)', 'Quienes buscan sistemas de hidroponía complejos y costosos', 'Aquellos que no están dispuestos a meter las manos en la tierra 10 minutos a la semana'];
  return <section ref={ref} className="w-full py-16 md:py-24 bg-gray-50" data-id="element-165">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-167">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D6A4F] mb-4" data-id="element-168">
            ¿Es Esto Para Ti?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-169">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-2xl p-8 border-2 border-[#52B788]" data-id="element-170">
            <h3 className="font-heading text-2xl font-bold text-[#2D6A4F] mb-6 flex items-center gap-2" data-id="element-171">
              <CheckCircle2Icon className="w-6 h-6" data-id="element-172" />
              Esto es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-173">
              {forItems.map((item, index) => <li key={index} className="flex gap-3" data-id="element-174">
                  <CheckCircle2Icon className="w-5 h-5 text-[#40916C] flex-shrink-0 mt-0.5" data-id="element-175" />
                  <span className="text-gray-700" data-id="element-176">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-177">
            <h3 className="font-heading text-2xl font-bold text-gray-700 mb-6 flex items-center gap-2" data-id="element-178">
              <XCircleIcon className="w-6 h-6" data-id="element-179" />
              NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-180">
              {notForItems.map((item, index) => <li key={index} className="flex gap-3" data-id="element-181">
                  <XCircleIcon className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-182" />
                  <span className="text-gray-600" data-id="element-183">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}